import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, getSpacing } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "TableGridstyle__Container",
  componentId: "sc-1sqxewt-0"
})(["position:absolute;top:", ";left:0;justify-content:center;padding:", ";background:", ";border:2px solid ", ";"], getSpacing(5), getSpacing(0.5), colorUsage.tableGrid.background, colorUsage.tableGrid.borderColor);
var Row = styled.div.withConfig({
  displayName: "TableGridstyle__Row",
  componentId: "sc-1sqxewt-1"
})(["display:flex;justify-content:space-between;"]);
var Cell = styled.div.withConfig({
  displayName: "TableGridstyle__Cell",
  componentId: "sc-1sqxewt-2"
})(["width:25px;height:25px;margin:2px;background-color:", ";border:", ";border-radius:", ";"], function (props) {
  return props.isSelected ? colorUsage.tableGrid.cell.background.selected : colorUsage.tableGrid.cell.background["default"];
}, function (props) {
  return props.isSelected ? "1px solid ".concat(colorUsage.tableGrid.cell.borderColor.selected) : "1px solid ".concat(colorUsage.tableGrid.cell.borderColor["default"]);
}, borderRadius.small);
var GridInfo = styled.div.withConfig({
  displayName: "TableGridstyle__GridInfo",
  componentId: "sc-1sqxewt-3"
})(["display:flex;align-items:center;justify-content:center;margin:", " auto;color:", ";font-size:", ";"], getSpacing(1), colorUsage.tableGrid.text, fontSize.large);
export { Cell, Container, GridInfo, Row };